var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 16.5667C12.5331 16.8167 12.4498 17.0833 12.2581 17.2583C11.9331 17.5833 11.4081 17.5833 11.0831 17.2583L7.74147 13.9167C7.5498 13.725 7.46647 13.4667 7.4998 13.225V8.95833L3.50813 3.85C3.2248 3.49167 3.29147 2.96667 3.6498 2.68333C3.80813 2.56667 3.98313 2.5 4.16647 2.5H15.8331C16.0165 2.5 16.1915 2.56667 16.3498 2.68333C16.7081 2.96667 16.7748 3.49167 16.4915 3.85L12.4998 8.95833V16.5667ZM5.86647 4.16667L9.16647 8.38333V12.9833L10.8331 14.65V8.375L14.1331 4.16667H5.86647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutline);
export default __webpack_public_path__ + "static/media/filter-outline.f94a177dd1ade174708e2a89b59489f1.svg";
export { ForwardRef as ReactComponent };